module.exports = __webpack_public_path__ + "media/images/top/voice/voice2-cc71c213b3fb7db5a9f6923a98008c19.png";